import React from 'react';
import {BrowserRouter, Route, Routes} from "react-router-dom";
import App from "../../App";
import Home from "../../pages/Home";
import Login from "../../pages/Login";
import CalculateImpact from "../../pages/CalculateImpact";
import {DishProvider} from "../../utils/contexts/dish-context";
import ProtectedRoute from "./ProtectedRoute";
import NotFound from "../../pages/NotFound";
import CalculateGdo from "../../pages/CalculateGdo";
import CalculateTabelog from "../../pages/CalculateTabelog";
import TabelogDataDisplay from "../CalculateTabelog/TabelogDataDisplay";
import OffDataDisplay from "../CalculateGdo/OffDataDisplay";
import UserInfoDisplay from "../UserInfo/UserInfoDisplay";
import Gs1DataDisplay from "../CalculateGs1/Gs1DataDisplay";


const Routing = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path='/' element={<App/>}>
                    <Route index element={<Home/>}/>
                    <Route path='userinfo' element={
                        <ProtectedRoute>
                            <DishProvider>
                                <UserInfoDisplay/>
                            </DishProvider>
                        </ProtectedRoute>
                    }/>
                    <Route path='impact/calculate' element={
                        <ProtectedRoute>
                            <DishProvider>
                                <CalculateImpact/>
                            </DishProvider>
                        </ProtectedRoute>
                    }/>
                    <Route path='gdo' element={
                        <ProtectedRoute>
                            <DishProvider>
                                <CalculateGdo/>
                            </DishProvider>
                        </ProtectedRoute>
                    }/>
                    <Route path='tabelog' element={
                        <ProtectedRoute>
                            <DishProvider>
                                <CalculateTabelog/>
                            </DishProvider>
                        </ProtectedRoute>
                    }/>
                    <Route path='tabelog_data' element={
                        <ProtectedRoute>
                            <DishProvider>
                                <TabelogDataDisplay/>
                            </DishProvider>
                        </ProtectedRoute>
                    }/>
                    <Route path='off_data' element={
                        <ProtectedRoute>
                            <DishProvider>
                                <OffDataDisplay/>
                            </DishProvider>
                        </ProtectedRoute>
                    }/>
                    <Route path='gs1_data' element={
                        <ProtectedRoute>
                            <DishProvider>
                                <Gs1DataDisplay/>
                            </DishProvider>
                        </ProtectedRoute>
                    }/>
                    <Route path='login' element={<Login/>}/>
                    <Route path='*' element={<NotFound/>}/>
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

export default Routing;
